<template>
 <div class="price">
  <Header></Header>
  <Partner></Partner>
 </div>
</template>

<script setup>
import Header from "./header.vue"
import Partner from "./partner.vue"

</script>

<style scoped lang="less">
.price {
 width: 100%;
 height: 100%;

}
</style>